import { render, staticRenderFns } from "./interactive-sidebar.vue?vue&type=template&id=151c8167&scoped=true&"
import script from "./interactive-sidebar.vue?vue&type=script&lang=js&"
export * from "./interactive-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c8167",
  null
  
)

export default component.exports